module.exports = __webpack_public_path__ + "img/cashier06.0b37519a.png";